import { render, staticRenderFns } from "./ClientProducts.vue?vue&type=template&id=8b6e0b92&"
import script from "./ClientProducts.vue?vue&type=script&lang=ts&"
export * from "./ClientProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports